import Ajax from '@/lib/ajax'
import Utils from '@/lib/util'

export default {
  getList(pageSize: number, currentPage: number, keyWord?: string) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      KeyWord: keyWord,
    }
    return Ajax.get('/api/OrderManagement/orderShippingFeeRule', {
      params,
    })
  },
  actionRules(type: any, data?: any, id?: string) {
    let url = id ? `/api/OrderManagement/orderShippingFeeRule/${id}` : `/api/OrderManagement/orderShippingFeeRule`
    if (type == 'get') {
      return Ajax.get(url)
    } else if (type == 'post') {
      return Ajax.post(url, data)
    } else if (type == 'put') {
      return Ajax.put(url, data)
    } else if (type == 'delete') {
      return Ajax.delete(`/api/OrderManagement/orderShippingFeeRule?id=${id}`)
    }
  },
}
